import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components'

const CulturalCard = ({ title, id }) => {
  return (
    <Wrapper>
      <Link to={`/gallery/cultural-activities/${title}/${id}`}>
        <div className="card">
          <h2>{title}</h2>
        </div>
      </Link>
    </Wrapper>
  );
};
const Wrapper = styled.div`
  .card {
    border: 2px solid #032B44; /* Navy blue border */
    border-radius: 10px; /* Optional: add some rounded corners */
    padding: 20px;
    height: 100%; 
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* Optional: add some shadow */
    transition: transform 0.3s ease-in-out; /* Optional: add some hover effect */
    &:hover {
      transform: scale(1.05);
    }
`

export default CulturalCard;